module.exports = "<div class=modal-content><div class=modal-body><div><iframe width=100% height=350 ng-src={{mdCtrl.modalOprions.video[mdCtrl.modalOprions.propertySrc]}}></iframe></div><div class=modal-footer style=\"margin: 0;padding: 10px 0 0;border: 0\"><button type=button class=\"btn btn-default\" ng-click=mdCtrl.cancel()>Cerrar</button></div></div></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/shared/components/modal-video/modal-video.view.html
 ** module id = 513
 ** module chunks = 8
 **/